import { Component, OnInit, PLATFORM_ID, inject } from '@angular/core';

import { LoadingLogoModule } from '@virginmediao2/momentum-angular';
import { CommonModule } from '@angular/common';
import { AuthService } from '@challenger/care/services/auth.service';
import { ApiService } from '../../services/api.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'vm-auth-deflection',
  templateUrl: './auth-deflection.component.html',
  standalone: true,
  imports: [CommonModule, LoadingLogoModule],
})
export class AuthDeflectionComponent implements OnInit {
  private apiService = inject(ApiService);
  private authService = inject(AuthService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  ngOnInit() {
    let returnUrl = sessionStorage.getItem('vmo2_seo_returnUrl');

    if (!returnUrl || returnUrl === '/help/how-to/auth-deflection') {
      returnUrl = '/help/how-to/tv/360-upgrade';
    }
    
    const checkAuthInterval = setInterval(() => {
      if (this.authService.isAuthenticated()) {
        clearTimeout(redirectToAppStart);
        clearInterval(checkAuthInterval);
        
        const pingFedAccess = sessionStorage.getItem(this.apiService.getPingFedAccessToken()) || '';
        this.apiService.findPingFedUser(pingFedAccess).subscribe(() => {
          this.router.navigate([returnUrl], { relativeTo: this.route });
        });
      }
    }, 100);

    const redirectToAppStart = setTimeout(() => {
      clearInterval(checkAuthInterval);
      clearTimeout(redirectToAppStart);

      this.router.navigate([returnUrl], { relativeTo: this.route });
    }, 505);
  }
}
